import type { ComponentProps, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import FocusedPageLayout from "@/layouts/FocusedPageLayout";
import Tabs from "@/components/Tabs";
import { careerProfileExperienceIndexHref, careerProfileGoalsHref } from "./careerPlanLatest";

type FocusedBackLink = NonNullable<ComponentProps<typeof FocusedPageLayout>["backLink"]>;

export default function CareerProfileFocusedChrome({
  pgaId,
  actions,
  activeTab,
  backLink,
  children
}: {
  pgaId: string;
  actions?: ReactNode;
  activeTab?: "goals" | "experience-index";
  backLink?: FocusedBackLink;
  children: ReactNode;
}) {
  const navigate = useNavigate();
  const tabItems =
    activeTab == null
      ? []
      : [
          {
            label: "Career Goals",
            active: activeTab === "goals",
            onClick: () => navigate(careerProfileGoalsHref(pgaId))
          },
          {
            label: "Experience Index Results",
            active: activeTab === "experience-index",
            onClick: () => navigate(careerProfileExperienceIndexHref(pgaId))
          }
        ];

  return (
    <FocusedPageLayout
      backLink={
        backLink ??
        ({
          to: "/people/:pgaId/career/career-profile",
          params: { pgaId },
          title: "Back"
        } as FocusedBackLink)
      }
      actions={actions}
      stickyActions
    >
      <PersonObjectHeading pgaId={pgaId} hideActions disableSticky />
      <div data-testid="career-plan-day-page">
        {tabItems.length > 0 ? <Tabs tabItems={tabItems} showWhenSingle /> : null}
        {children}
      </div>
    </FocusedPageLayout>
  );
}
